@if (breadcrumbs().length) {
  <nav class="breadcrumbs" aria-label="Breadcrumb">
    <ol class="crumbs">
      @for (crumb of breadcrumbs(); track $index; let last = $last, first = $first) {
        <li class="crumb" [class.crumb--first]="first" [class.crumb--last]="last">
          @if (!last && crumb.route) {
            <a
              class="crumb-link"
              [routerLink]="crumb.route"
              [queryParams]="crumb.queryParams || null"
              >{{ crumb.label }}</a
            >
          } @else if (!last) {
            <span class="crumb-text">{{ crumb.label }}</span>
          } @else {
            <span class="crumb-current" aria-current="page">{{ crumb.label }}</span>
          }
        </li>
      }
    </ol>
  </nav>
}
